import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { ThemeType } from 'styles/colorMode';

const themeDataAttr: Record<ThemeType, string | null> = {
    [ThemeType.light]: null,
    [ThemeType.dark]: 'dark',
    [ThemeType.night]: 'night',
};

export function GlobalThemeStyles() {
    const { colorMode } = useTheme();

    useEffect(() => {
        const html = document.documentElement;
        const attr = themeDataAttr[colorMode];
        if (attr) {
            html.dataset.theme = attr;
            html.classList.add(`theme-${attr}`);
            // Remove classes for other dark themes
            for (const other of Object.values(themeDataAttr)) {
                if (other && other !== attr) {
                    html.classList.remove(`theme-${other}`);
                }
            }
        } else {
            delete html.dataset.theme;
            html.classList.remove('theme-dark', 'theme-night');
        }
    }, [colorMode]);

    return null;
}
